import { render, staticRenderFns } from "./Muraflex.vue?vue&type=template&id=10f7f080&"
import script from "./Muraflex.vue?vue&type=script&lang=ts&"
export * from "./Muraflex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports